import { motion } from "framer-motion";
import { ArrowDownRight } from "lucide-react";
import { IMAGES } from "../../data/site";

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
});

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 md:pt-44 pb-20 md:pb-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
        <div className="lg:col-span-7">
          <motion.h1
            {...fade(0.1)}
            className="font-display text-[44px] leading-[1.02] sm:text-6xl lg:text-[88px] tracking-tighter font-medium text-[#0A0A0A]"
          >
            Software systems,
            <br />
            engineered with
            <span className="italic text-[#2F6B1F]"> intent.</span>
          </motion.h1>

          <motion.p
            {...fade(0.25)}
            className="mt-8 text-lg md:text-xl text-[#404040] max-w-xl leading-relaxed"
          >
            MB Prism is a Canadian IT consulting practice. We design,
            build and modernize the systems that finance, healthcare
            and public-sector teams depend on every day.
          </motion.p>

          <motion.div
            {...fade(0.4)}
            className="mt-10 flex flex-col sm:flex-row gap-4"
          >
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("services")}
              className="bg-[#2F6B1F] text-white px-7 py-4 font-medium tracking-tight hover:bg-[#FF331F] transition-colors duration-300 flex items-center justify-center gap-2"
            >
              Explore services
              <ArrowDownRight size={18} />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => scrollTo("work")}
              className="border border-[#0A0A0A] text-[#0A0A0A] px-7 py-4 font-medium hover:bg-[#0A0A0A] hover:text-white transition-colors duration-300"
            >
              See selected work
            </button>
          </motion.div>
        </div>

        <motion.div
          {...fade(0.35)}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] w-full overflow-hidden border border-black/10">
            <img
              src={IMAGES.hero}
              alt="Architectural detail"
              className="w-full h-full object-cover"
              loading="eager"
            />
            <div className="absolute bottom-0 left-0 right-0 p-5 bg-white/95 backdrop-blur border-t border-black/10">
              <div className="flex items-center justify-between text-xs font-mono-ibm">
                <span className="text-[#404040]">FILE / 001</span>
                <span className="text-[#2F6B1F]">MB-PRISM · 2025</span>
              </div>
              <div className="mt-2 font-display text-lg tracking-tight leading-tight">
                Built for resilient, regulated environments.
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Bottom strip */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-20 md:mt-28 border-t border-black/10 pt-6 grid grid-cols-2 md:grid-cols-4 gap-3 font-mono-ibm text-xs">
        <span className="text-[#2F6B1F]">[ 01 ] Analysis</span>
        <span className="text-[#1E4FB8]">[ 02 ] Architecture</span>
        <span className="text-[#FF331F]">[ 03 ] Engineering</span>
        <span className="text-[#F5A524]">[ 04 ] Operations</span>
      </div>
    </section>
  );
}
